"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3220],{

/***/ 93220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55760);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2595);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88751);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96301);








const Embed = (props)=>{
    const { data: { script ="" , matterportUrl ="" , visualIcon =false , html ="" , etype =""  } = {}  } = props;
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const [stylesVal, setStylesVal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [reloadStyles, setReloadStyles] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { pageIsInteractive  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_5__.selectGenericState);
    const etypeUppercase = etype === null || etype === void 0 ? void 0 : etype.toUpperCase();
    const datalayerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    const servicesClick = (e)=>{
        const { target: { href ="" , textContent =""  } = {}  } = e;
        datalayerForCookie(textContent, href);
        window.open(href);
    };
    const datalayerForCookie = (text, url)=>{
        const textCont = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__.sanitizeTextForAnalytics)(text);
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "legal:cookie policy:".concat(textCont),
            eventMsg: "n/a",
            eventName: "legal:cookie policy:".concat(textCont),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: "".concat(textCont),
            internalLinkPosition: "kohler:legal:cookie policy",
            internalLinkType: "kohler:legal:cookie policy:one trust",
            internalLinkURL: url,
            internalLinkZoneName: "kohler:legal:cookie policy:".concat(textCont)
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click");
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isSsr && pageIsInteractive) {
            const { styles =[]  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__.isEmbeddedStyles)(script);
            setStylesVal(styles);
            if (!reloadStyles) {
                // This is to make sure any 3rdParty Component loaded to the page will get styles applied after loading
                setTimeout(function() {
                    setReloadStyles(true);
                    dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_5__.toggleSiteWideWarning)());
                }, 3000);
            }
        }
    }, [
        isSsr,
        pageIsInteractive,
        reloadStyles
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (datalayerRef === null || datalayerRef === void 0 ? void 0 : datalayerRef.current) {
            var ref;
            datalayerRef === null || datalayerRef === void 0 ? void 0 : (ref = datalayerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                if ((item === null || item === void 0 ? void 0 : item.getAttribute("listener")) !== "true") {
                    item === null || item === void 0 ? void 0 : item.addEventListener("click", (e)=>{
                        servicesClick(e);
                    });
                }
            });
        }
        return ()=>{
            var ref;
            datalayerRef === null || datalayerRef === void 0 ? void 0 : (ref = datalayerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                item === null || item === void 0 ? void 0 : item.removeEventListener("click", servicesClick);
            });
        };
    }, [
        isSsr
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ref: datalayerRef,
        children: [
            !isSsr && visualIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "gbh-visual-icons",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "gbh-visual-icon-area",
                    tabIndex: "0",
                    role: "button",
                    "aria-label": _constants_index__WEBPACK_IMPORTED_MODULE_6__.VISUALICON_ARIA_LABEL
                })
            }),
            !isSsr && etypeUppercase === _constants_index__WEBPACK_IMPORTED_MODULE_6__.EMBED_TYPE_HTML && html && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "embed",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "cmp-embed",
                    dangerouslySetInnerHTML: {
                        __html: html
                    }
                })
            }),
            !isSsr && etypeUppercase === _constants_index__WEBPACK_IMPORTED_MODULE_6__.EMBED_TYPE_SCRIPT && (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__.isEmbeddedElement)(script) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "embed",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "cmp-embed",
                    dangerouslySetInnerHTML: {
                        __html: script
                    }
                })
            }),
            pageIsInteractive && etypeUppercase === _constants_index__WEBPACK_IMPORTED_MODULE_6__.EMBED_TYPE_SCRIPT && stylesVal.map((style, i)=>{
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        id: "embedStyle-".concat(i, "-").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__.getRandom)()),
                        children: style
                    })
                }, "embedStyle-".concat(i, "-").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__.getRandom)()));
            }),
            !isSsr && matterportUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "modal fade virtual-tour-popup",
                tabIndex: "-1",
                role: "dialog",
                "aria-labelledby": _constants_index__WEBPACK_IMPORTED_MODULE_6__.MATTERPORT_ARIA_LABEL,
                "aria-hidden": "true",
                "data-keyboard": "false",
                "data-backdrop": "static",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "modal-dialog",
                    role: "document",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "modal-content",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "modal-body",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    className: "close",
                                    "data-dismiss": "modal",
                                    "aria-label": "Close",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        "aria-hidden": "true",
                                        children: "\xd7"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                                    src: matterportUrl,
                                    title: "",
                                    style: {
                                        width: "100%",
                                        height: "800px",
                                        border: "0"
                                    },
                                    allowFullScreen: true
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Embed);


/***/ })

}]);